import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Modal,
  TextField,
  TableContainer,
  IconButton,
  Paper,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme,
  styled,
  InputAdornment,
  alpha,
  Divider,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import ManagementSidebar from "./ManagementSidebar";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import axios from "axios";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomCircleCheck from "../../Common/CircleCheck";
import ModalContent from "../../Common/Modal";
import { HeaderText } from "../../Common/AllText";
import { ContainedButton } from "../../Common/Buttons";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import CallSplitOutlinedIcon from "@mui/icons-material/CallSplitOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";

const countryWithUSDCurrency = ["Canada", "United States"];

const ASSETICONBASEURL =
  "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/";

const FUTURELENDINGURL = WEBSERVICE + "/fMargin/";
const OPTIONSLENDINGURL = WEBSERVICE + "/optionsMargin/";

const AssetManagement = () => {
  const themecolor = localStorage.getItem("theme");
  const navigate = useNavigate();
  const location = useLocation();
  const userCountry = localStorage.getItem("userCountry");
  const openIndex = location.state?.openIndex;
  const { brokerBasicInfo, btncolor, brokerMarkets } = useSelector((state) => state);
  const walletList = [];
  const [selectedSubAccount, setSelectedSubAccount] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const [activeTab, setActiveTab] = useState("spot");
  const [nestedTab, setNestedTab] = useState(0);

  const [selectedFromAccount, setSelectedFromAccount] = useState("");
  const [selectedToAccount, setSelectedToAccount] = useState("");
  const [selectedFromWallet, setSelectedFromWallet] = useState("spot");
  const [selectedToWallet, setSelectedToWallet] = useState("spot");
  const [selectedMargin, setSelectedMargin] = useState("");
  const [selectedCurrencyCode, setSelectedCurrencyCode] = useState("");
  const [selectedFuturesCurrencyId, setSelectedFuturesCurrencyId] =
    useState("");
  const [selectedOptionsCurrencyId, setSelectedOptionsCurrencyId] =
    useState("");
  const [selectedChildCurrencyCode, setSelectedChildCurrencyCode] =
    useState("");
  const [fmarginIsoCurrcode, setFmarginIsoCurrcode] = useState("");
  const [transferAmt, setTransferAmt] = useState("");
  const [subAccountsData, setSubAccountsData] = useState([]);
  const [selectedUuid, setSelectedUuid] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [walletType, setWalletType] = useState("spot");
  const [marginType, setMarginType] = useState(1);
  const [myBalanceList, setMyBalanceList] = useState([]);
  const [selectedCurrencyId, setSelectedCurrencyId] = useState("");

  const [tabIndex, setTabIndex] = useState(0);
  const [infoSection, setInfoSection] = useState("");
  const [futureChildTab, setFutureChildTab] = useState("futureWalletIso");
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [infoContent, setInfoContent] = useState({ title: "", content: "" });
  const [twoFactorModal, setTwoFactorModal] = useState("");
  const [twoFactorOtp, setTwoFactorOtp] = useState("");

  const [showEmptyList, setShowEmptyList] = useState(false);
  const [showSubAccountList, setShowSubAccountList] = useState(true);
  const [showParentList, setShowParentList] = useState(false);
  const [isFromWalletSpot, setIsFromWalletSpot] = useState(false);
  const [isToWalletSpot, setIsToWalletSpot] = useState(false);
  const [marginTypeList, setMarginTypeList] = useState(false);
  const [showAssetList, setShowAssetList] = useState(false);
  const [parentAssetToTransfer, setParentAssetToTransfer] = useState(false);
  const [childAssetToTransfer, setChildAssetToTransfer] = useState(false);
  const [
    futureIsoMarginWalletCurrencyList,
    setFutureIsoMarginWalletCurrencyList,
  ] = useState(false);
  const [isTransferBtn, setIsTransferBtn] = useState(false);

  const [selectedBalance, setSelectedBalance] = useState(undefined);
  const [selectedFuturesBalance, setSelectedFuturesBalance] =
    useState(undefined);
  const [selectedOptionsBalance, setSelectedOptionsBalance] =
    useState(undefined);
  const [selectedChildBalance, setSelectedChildBalance] = useState(undefined);
  const [parentEmail, setParentEmail] = useState("");
  const [parentId, setParentId] = useState("");
  const [parentEmailValue, setParentEmailValue] = useState("");
  const [myBalanceListArray, setMyBalanceListArray] = useState([]);
  const [fmarginWalletCurrency, setFmarginWalletCurrency] = useState("");

  const [transferFromAccount, setTransferFromAccount] = useState("");
  const [transferFromEmail, setTransferFromEmail] = useState("");
  const [transferToAccount, setTransferToAccount] = useState(null);
  const [transferToEmail, setTransferToEmail] = useState("");

  const [selectedLeverageType, setSelectedLeverageType] = useState("");
  const [fmarginType, setFmarginType] = useState(null);
  const [fmarginWalletBalance, setFmarginWalletBalance] = useState("");
  const [fmarginWalletCurrencyId, setFmarginWalletCurrencyId] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const [isIsolated, setIsIsolated] = useState(false);

  const [futureAssets, setFutureAssets] = useState(false);
  const [optionsAssets, setOptionsAssets] = useState(false);

  const [selectedFutureCurrencyName, setSelectedFutureCurrencyName] =
    useState("");
  const [selectedOptionsCurrencyName, setSelectedOptionsCurrencyName] =
    useState("");

  const [futureCurrencyNameArr, setFutureCurrencyNameArr] = useState([]);
  const [optionsCurrencyNameArr, setOptionsCurrencyNameArr] = useState([]);

  console.log("isDisable", isDisable);
  const getListOfAllSubAccounts = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/getAllSubAccounts`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;

      if (res.statusCode !== 0) {
        showToast("error", res.message);
      } else {
        setSubAccountsData(res["sub accounts"]);
      }
    } catch (error) {
      showToast("error", "Something went wrong!");
    }
  };

  useEffect(() => {
    setParentEmail(localStorage.getItem("email"));
    setParentId(localStorage.getItem("uuid"));
    getListOfAllSubAccounts();
  }, []);

  useEffect(() => {
    if (brokerMarkets && brokerMarkets.isAssetMgmt === 0) {
      navigate("/settings");
      showToast("error", "You don't have permission to view that page");
    }
  }, [brokerMarkets, navigate]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setNestedTab(0);
  };

  const filterSubAccountData = subAccountsData?.map((d) => ({
    id: d?.uuid,
    email: d?.email,
  }));

  const getSubAccountsData = [
    { uuid: "1", email: "sub1@example.com" },
    { uuid: "2", email: "sub2@example.com" },
    { uuid: "3", email: "sub3@example.com" },
  ];

  const resetTransferVal = () => {
    setSelectedFromWallet("");
    setSelectedToWallet("");
    setTransferAmt("");
    setSelectedCurrencyId("");
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelectedFromAccount("");
    setSelectedToAccount("");
    setSelectedToWallet("");
    setSelectedFromWallet("");
    setTransferAmt("");
    setSelectedCurrencyId("");
    setFmarginType("");
    setParentEmailValue("");
    setFutureAssets(false);
    setOptionsAssets(false);
    setSelectedBalance(undefined);
    setSelectedChildBalance(undefined);
    setSelectedCurrencyCode("");
    setSelectedFutureCurrencyName("");
    setSelectedFuturesBalance(undefined);
    setSelectedOptionsBalance(undefined);
    setSelectedOptionsCurrencyName("");
    setSelectedCurrencyId("");
  };

  const resetValues = () => {
    setSelectedFromAccount("");
    setSelectedToAccount("");
    setSelectedToWallet("");
    setSelectedFromWallet("");
    setTransferAmt("");
    setSelectedCurrencyId("");
    setFmarginType("");
    setParentEmailValue("");
    setFutureAssets(false);
    setOptionsAssets(false);
    setSelectedBalance(undefined);
    setSelectedChildBalance(undefined);
    setSelectedCurrencyCode("");
    setSelectedFutureCurrencyName("");
    setSelectedFuturesBalance(undefined);
    setSelectedOptionsBalance(undefined);
    setSelectedOptionsCurrencyName("");
    setSelectedCurrencyId("");
    setSelectedFromWallet("");
    setSelectedToWallet("");
    setTransferAmt("");
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedSubAccount(value);
    onEmailSelected(value);
  };

  const onEmailSelected = (account) => {
    console.log("setSelectedUuid", account);
    setSelectedUuid(account?.uuid);
    setSelectedEmail(account?.email);
    showSubAccountBalance(walletType, "");
  };

  useEffect(() => {
    showSubAccountBalance(walletType, "");
  }, [selectedUuid]);

  const showSubAccountBalance = (value, mType) => {
    if (!selectedUuid) return;
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      walletType: value,
    };

    if (value !== "spot") {
      payload["marginType"] = mType;
    }

    axios
      .post(
        `${WEBSERVICE}assetManagement/getSubAccountBalance`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((response) => {
        const res = response.data;
        const arr = res.balance || [];
        setMyBalanceList(arr);
        setMyBalanceListArray(arr);
      })
      .catch((error) => {
        if (error.response?.data?.error) {
          console.error(error.response.data.error);
          showToast("error", error.response.data.error);
        }
      });
  };

  const handleFutureChildTabChange = (event, newValue) => {
    setFutureChildTab(newValue);
    handleSelectedTab("futuresWallet");
  };

  const handleInfoClick = (title, content) => {
    setInfoContent({ title, content });
    setOpenInfoDialog(true);
  };

  const handleCloseInfoDialog = () => {
    setOpenInfoDialog(false);
  };

  const infoSections = {
    assetInfo: {
      title: "Asset",
      content:
        "This column displays the name of currencies listed in the exchange.",
    },
    holdingInfo: {
      title: "Holdings",
      content: "Holdings displays the balance of a particular currency.",
    },
    isolatedInfo: {
      title: "Isolated",
      content:
        "Isolated Margin is the margin balance allocated to an individual position. Isolated Margin mode allows traders to manage their risk on their individual positions by restricting the amount of margin allocated to each one. The allocated margin balance for each position can be individually adjusted.",
    },
    crossInfo: {
      title: "Cross",
      content:
        "Cross Wallet is a crypto wallet built to hold multiple blockchain cryptocurrencies in one wallet.",
    },
  };

  const handleSelectedTab = (param) => {
    const alreadySelectedTab = localStorage.getItem(
      "last_selected_tab_of_wallet"
    );
    let isAbleToSave = true;

    if (alreadySelectedTab !== undefined && alreadySelectedTab !== null) {
      if (
        param === "margin" &&
        [
          "marginIso",
          "marginCross",
          "marginIsoWallet",
          "marginIsoPortfolio",
          "marginCrossWallet",
          "marginCrossPortfolio",
        ].includes(alreadySelectedTab)
      ) {
        isAbleToSave = false;
      } else if (
        param === "marginIso" &&
        ["marginIsoWallet", "marginIsoPortfolio"].includes(alreadySelectedTab)
      ) {
        isAbleToSave = false;
      } else if (
        param === "marginCross" &&
        ["marginCrossWallet", "marginCrossPortfolio"].includes(
          alreadySelectedTab
        )
      ) {
        isAbleToSave = false;
      } else if (
        param === "futures" &&
        [
          "futuresCurrentQuarter",
          "futuresNextQuarter",
          "futuresPerpetual",
        ].includes(alreadySelectedTab)
      ) {
        isAbleToSave = false;
      }
    }

    if (isAbleToSave) {
      localStorage.setItem("last_selected_tab_of_wallet", param);
    }
  };

  const marketTypeNavSeve = (e) => {
    localStorage.setItem("walletMarketTpeNavHist", e);
  };
  const futureChildNavHist = (e) => {
    localStorage.setItem("futureChildNavHist", e);
  };
  const saveOptionChildNavHist = (e) => {
    localStorage.setItem("optionChildNavHist", e);
  };

  const checkUserBlockStatus = async () => {
    const payload = {
      uuid: localStorage.getItem("uuid"),
    };
    try {
      const response = await fetch(`${WEBSERVICE}user/userAccountStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 401) {
        showToast("error", "Session Timeout. Login Again");
        return false;
      }

      const data = await response.json();
      if (data.error?.error_data !== 0) {
        showToast("error", data.error.error_msg);
        return false;
      } else {
        if (data.status !== 1) {
          showToast("error", "Your user has been blocked by Admin");
          return false;
        } else {
          return true;
        }
      }
    } catch (error) {
      console.error("Request failed", error);
      showToast("error", "An error occurred while checking user status");
      return false;
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const getParentBalanceTransactionList = async () => {
    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const balance = response.data.userBalanceList || [];
      const arr = balance.map((item) => item);
      console.log(arr);
      setMyBalanceListArray(arr);
    } catch (error) {
      console.error("Error fetching balance list:", error);
    }
  };

  const handleFromAccountChange = (e) => {
    resetValues();
    const id = e.target.value;
    setSelectedFromAccount(id);
    const selectedAccount =
      id === parentId
        ? { id: parentId, email: parentEmail }
        : filterSubAccountData.find((item) => item.id === id);
    selectedFromAcc(selectedAccount);
  };

  const selectedFromAcc = (value) => {
    const { id, email } = value;
    setTransferFromAccount(id);
    setTransferFromEmail(email);

    if (email === parentEmail) {
      getParentBalanceTransactionList();
      setShowSubAccountList(true);
      setShowEmptyList(false);
      setShowParentList(false);
      setIsFromWalletSpot(false);
      console.log("from account iffjkjdfk");
    } else {
      setSelectedUuid(id);
      showSubAccountBalance(walletType, "");
      setShowEmptyList(false);
      setShowSubAccountList(false);
      setShowParentList(true);
      setParentEmailValue(parentEmail);
      setIsFromWalletSpot(true);
      setFutureAssets(false);
      console.log("from account elseeee");
    }
  };
  console.log("from account ---", isFromWalletSpot);

  const selectedToAcc = (value) => {
    setSelectedToAccount(value);
    const { id, email } = value;
    setTransferToAccount(id);
    setTransferToEmail(email);
  };

  const selectTransferFromWallet = (value) => {
    console.log("TRANSFORM FROM WALLET", value);
    setSelectedFromWallet(value);
    setSelectedFutureCurrencyName("");
    setSelectedOptionsCurrencyName("");

    if (value === "spot" && selectedFromAccount === parentId) {
      setMarginTypeList(false);
      setShowAssetList(true);
      setFutureIsoMarginWalletCurrencyList(false);
      setIsToWalletSpot(false);
      setParentAssetToTransfer(true);
      setChildAssetToTransfer(false);
      setSelectedBalance(undefined);
      setSelectedOptionsBalance(undefined);
      setSelectedFuturesBalance(undefined);
      setSelectedChildBalance(undefined);
    } else if (value === "futures") {
      getFuturesCurrencyList();
      setMarginTypeList(true);
      setShowAssetList(false);
      setFutureAssets(true);
      setOptionsAssets(false);
      setParentAssetToTransfer(false);
      setChildAssetToTransfer(false);
      setFutureIsoMarginWalletCurrencyList(false);
      setIsToWalletSpot(true);
      setIsIsolated(true);
      setSelectedMargin("");
      setSelectedBalance(undefined);
      setSelectedOptionsBalance(undefined);
      setSelectedFuturesBalance(undefined);
      setSelectedChildBalance(undefined);
    } else if (value === "options") {
      getOptionsCurrencyList();
      setMarginTypeList(true);
      setIsIsolated(false);
      setSelectedMargin("cross");
      setShowAssetList(false);
      setOptionsAssets(true);
      setFutureAssets(false);
      setChildAssetToTransfer(false);
      setParentAssetToTransfer(false);
      setFutureIsoMarginWalletCurrencyList(false);
      setIsToWalletSpot(true);
      setSelectedBalance(undefined);
      setSelectedOptionsBalance(undefined);
      setSelectedFuturesBalance(undefined);
      setSelectedChildBalance(undefined);
    } else if (value === "spot" && selectedFromAccount !== parentId) {
      setMarginTypeList(false);
      setShowAssetList(false);
      setFutureIsoMarginWalletCurrencyList(false);
      setParentAssetToTransfer(true);
      setFutureAssets(false);
      setOptionsAssets(false);
      setIsToWalletSpot(true);
      setSelectedBalance(undefined);
      setSelectedOptionsBalance(undefined);
      setSelectedFuturesBalance(undefined);
      setSelectedChildBalance(undefined);
    } else if (value === "futures" && selectedFromAccount !== parentId) {
      setOptionsAssets(false);
      setShowAssetList(false);
      setParentAssetToTransfer(false);
      setFutureIsoMarginWalletCurrencyList(false);
      setSelectedBalance(undefined);
      setSelectedOptionsBalance(undefined);
      setSelectedFuturesBalance(undefined);
      setSelectedChildBalance(undefined);
    }
    if (value === "options") {
      setSelectedMargin("cross");
    } else {
      setSelectedMargin("");
    }
  };

  const getFuturesCurrencyList = () => {
    axios
      .get(`${FUTURELENDINGURL}fundingHomeView`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        console.log("OPTIONS CURRENCY", response.data);
        const currencyListArr = response.data.P_FUNDING_CURRENCY;
        const currname = [];
        for (let i = 0; i < currencyListArr.length; i++) {
          currname.push(currencyListArr[i]);
        }
        console.log(currname);
        setFutureCurrencyNameArr(currname);
      })
      .catch((error) => {
        console.error("Error fetching Futures Currency List:", error);
      });
  };

  const getOptionsCurrencyList = () => {
    axios
      .get(`${OPTIONSLENDINGURL}fundingHomeView`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const currencyListArr = response.data.P_FUNDING_CURRENCY;
        const currname = [];
        for (let i = 0; i < currencyListArr.length; i++) {
          currname.push(currencyListArr[i]);
        }
        console.log(currname);
        setOptionsCurrencyNameArr(currname);
      })
      .catch((error) => {
        console.error("Error fetching Options Currency List:", error);
      });
  };

  const selectTransferToWallet = (value) => {
    setSelectedToWallet(value);
    console.log("TRANSFER TO WALLET", selectedToWallet);

    if (
      selectedFromWallet === "spot" &&
      value === "spot" &&
      selectedFromAccount !== parentId
    ) {
      setMarginTypeList(false);
      setChildAssetToTransfer(false);
      setParentAssetToTransfer(true);
      setFutureAssets(false);
      setOptionsAssets(false);
      setShowAssetList(false);
    } else if (
      selectedFromWallet === "spot" &&
      value === "spot" &&
      selectedFromAccount === parentId
    ) {
      setMarginTypeList(false);
      getParentBalanceTransactionList();
      setParentAssetToTransfer(true);
      setFutureAssets(false);
      setOptionsAssets(false);
      setShowAssetList(false);
    } else if (
      selectedFromWallet === "spot" &&
      value === "futures" &&
      selectedFromAccount === parentId
    ) {
      setMarginTypeList(true);
      setIsIsolated(true);
      setSelectedMargin("");
      getFuturesCurrencyList();
      setParentAssetToTransfer(false);
      setFutureAssets(true);
      setOptionsAssets(false);
      setShowAssetList(false);
    } else if (
      selectedFromWallet === "spot" &&
      value === "options" &&
      selectedFromAccount === parentId
    ) {
      setMarginTypeList(true);
      setIsIsolated(false);
      setSelectedMargin("cross");
      getOptionsCurrencyList();
      setParentAssetToTransfer(false);
      setFutureAssets(false);
      setOptionsAssets(true);
      setShowAssetList(false);
    } else if (
      selectedFromWallet === "spot" &&
      value === "futures" &&
      selectedFromAccount === parentId
    ) {
      setMarginTypeList(true);
    }
  };

  const getSpecificCurrencyPrecision = (param) => {
    const list = JSON.parse(localStorage.getItem("precision_list_json")) || [];
    const matchedItem = list.find(
      (item) =>
        item.CURRENCYID === param ||
        item.CURRENCY === String(param).toUpperCase()
    );
    return matchedItem ? matchedItem.PRECISION : 0;
  };

  const selectMarginForTransfer = async (value) => {
    setSelectedMargin(value);
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const headers = {
      "Content-Type": "application/json",
      authorization: "BEARER " + token,
    };

    const buildUrl = (baseUrl, marginType, currencyName, leverage) => {
      return `${baseUrl}getMarginWalletByCurrency?uuid=${uuid}&currencyName=${currencyName}&marginType=${marginType}&leverage=${leverage}`;
    };

    try {
      if (
        selectedFromAccount === parentId &&
        selectedFromWallet === "futures" &&
        value === "iso"
      ) {
        setFmarginType(1);
        const url = buildUrl(FUTURELENDINGURL, 1, "USD", selectedLeverageType);
        const { data } = await axios.get(url, { headers });

        if (data.error !== 1) {
          console.log("future margin balance:", data);
          setFmarginWalletCurrency(data.currencyName);
          setFmarginWalletBalance(
            data.availableBalance.toFixed(getSpecificCurrencyPrecision("USD"))
          );
          setFmarginWalletCurrencyId(data.currencyId);
          setFutureIsoMarginWalletCurrencyList(true);
          setParentAssetToTransfer(false);
          setShowAssetList(false);
        } else {
          setFutureIsoMarginWalletCurrencyList(false);
          setShowAssetList(false);
        }
      } else if (
        selectedFromAccount === parentId &&
        selectedFromWallet === "futures" &&
        value === "cross"
      ) {
        setFmarginType(2);
        const url = buildUrl(FUTURELENDINGURL, 2, "USD", selectedLeverageType);
        const { data } = await axios.get(url, { headers });

        if (data.error !== 1) {
          console.log("future margin balance:", data);
          setFmarginWalletCurrency(data.currencyName);
          setFmarginWalletBalance(
            data.availableBalance.toFixed(getSpecificCurrencyPrecision("USD"))
          );
          setFmarginWalletCurrencyId(data.currencyId);
          setFutureIsoMarginWalletCurrencyList(true);
          setParentAssetToTransfer(false);
          setShowAssetList(false);
        } else {
          setFutureIsoMarginWalletCurrencyList(false);
          setShowAssetList(false);
        }
      } else if (
        selectedFromAccount === parentId &&
        selectedFromWallet === "options" &&
        value === "cross"
      ) {
        const url = buildUrl(
          OPTIONSLENDINGURL,
          2,
          "USDT",
          selectedLeverageType
        );
        const { data } = await axios.get(url, { headers });

        if (data.error !== 1) {
          console.log("options margin balance:", data);
          setFmarginWalletCurrency(data.currencyName);
          setFmarginWalletBalance(
            data.availableBalance.toFixed(getSpecificCurrencyPrecision("USD"))
          );
          setFmarginWalletCurrencyId(data.currencyId);
          setFutureIsoMarginWalletCurrencyList(true);
          setParentAssetToTransfer(false);
          setShowAssetList(false);
        } else {
          setFutureIsoMarginWalletCurrencyList(false);
          setShowAssetList(false);
        }
      } else if (
        selectedFromAccount === parentId &&
        selectedFromWallet === "spot" &&
        value === "iso"
      ) {
        setFmarginType(1);
      } else if (
        selectedFromAccount === parentId &&
        selectedFromWallet === "spot" &&
        value === "cross"
      ) {
        setFmarginType(2);
      }
    } catch (error) {
      console.error("Error fetching margin wallet:", error);
      setFutureIsoMarginWalletCurrencyList(false);
      setShowAssetList(false);
    }
  };

  const onFutureCurrencyChange = async (value) => {
    setSelectedFutureCurrencyName(value);
    if (selectedFromAccount !== parentId) {
      const payload = {
        parentId: localStorage.getItem("uuid"),
        uuid: selectedUuid,
        walletType: "futures",
        marginType:
          selectedMargin === "iso"
            ? "1"
            : selectedMargin === "cross"
            ? "2"
            : undefined,
      };

      try {
        const res = await axios.post(
          `${WEBSERVICE}assetManagement/getSubAccountBalance`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        );

        console.log("FUTURE CURR LIST", res.data);
        const childfutureBalance = res.data.balance;

        const selectedCurrency = childfutureBalance.find(
          (item) => item.currencyCode === value
        );

        setSelectedFuturesBalance(selectedCurrency.closingBalance);
        setSelectedFuturesCurrencyId(selectedCurrency.currencyId);
        setSelectedCurrencyId(selectedCurrency.currencyId);

        setSelectedBalance(undefined);
        setSelectedOptionsBalance(undefined);
        setSelectedChildBalance(undefined);
        setSelectedOptionsCurrencyName("");
        setSelectedCurrencyCode("");
      } catch (error) {
        console.error("Error fetching subaccount balance:", error);
      }
    } else {
      const userTransObj = {
        customerId: localStorage.getItem("userId"),
        uuid: localStorage.getItem("uuid"),
      };

      try {
        const res = await axios.post(
          `${WEBSERVICE}transaction/getUserBalance`,
          JSON.stringify(userTransObj),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        );

        console.log("RESULT", res.data);
        const futureBalance = res.data.userBalanceList;

        const selectedCurrency = futureBalance.find(
          (item) => item.currencyCode === value
        );

        setSelectedFuturesBalance(selectedCurrency.closingBalance);
        setSelectedFuturesCurrencyId(selectedCurrency.currencyId);
        setSelectedCurrencyId(selectedCurrency.currencyId);

        setSelectedBalance(undefined);
        setSelectedOptionsBalance(undefined);
        setSelectedChildBalance(undefined);
        setSelectedOptionsCurrencyName("");
        setSelectedCurrencyCode("");
      } catch (error) {
        console.error("Error fetching user balance:", error);
      }
    }
  };

  const onOptionCurrencyChange = async (value) => {
    setSelectedOptionsCurrencyName(value);
    if (selectedFromAccount !== parentId) {
      const payload = {
        parentId: localStorage.getItem("uuid"),
        uuid: selectedUuid,
        walletType: "options",
        marginType: "2",
      };

      axios
        .post(
          `${WEBSERVICE}assetManagement/getSubAccountBalance`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        )
        .then((response) => {
          console.log("OPTIONS CURR LIST", response.data);
          const childOptionsBalance = response.data.balance || [];

          const matched = childOptionsBalance.find(
            (item) => item.currencyCode === value
          );

          console.log("matcheddddd", matched);

          if (matched) {
            setSelectedOptionsBalance(matched.closingBalance);
            setSelectedCurrencyId(matched.currencyId);
          } else {
            setSelectedOptionsBalance(0);
          }

          setSelectedBalance(undefined);
          setSelectedFuturesBalance(undefined);
          setSelectedChildBalance(undefined);
          setSelectedFutureCurrencyName("");
          setSelectedCurrencyCode("");
        })
        .catch((error) => {
          console.error("Error fetching sub-account balance:", error);
        });
    } else {
      console.log("CURRENCY MATCHED");
      const userTransObj = {
        customerId: localStorage.getItem("userId"),
        uuid: localStorage.getItem("uuid"),
      };

      axios
        .post(
          `${WEBSERVICE}transaction/getUserBalance`,
          JSON.stringify(userTransObj),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        )
        .then((response) => {
          console.log("RESULT", response.data);
          const optionsBalance = response.data.userBalanceList || [];

          const matched = optionsBalance.find(
            (item) => item.currencyCode === value
          );

          if (matched) {
            setSelectedOptionsBalance(matched.closingBalance);
            setSelectedCurrencyId(matched.currencyId);
          }

          setSelectedBalance(undefined);
          setSelectedFuturesBalance(undefined);
          setSelectedChildBalance(undefined);
          setSelectedFutureCurrencyName("");
          setSelectedCurrencyCode("");
        })
        .catch((error) => {
          console.error("Error fetching user balance:", error);
        });
    }
  };

  const onCurrencyChange = (value) => {
    setSelectedCurrencyCode(value);
    const selectedCurrencyObj = myBalanceListArray?.find(
      (currency) => currency.currencyCode === value
    );

    if (selectedCurrencyObj) {
      setSelectedBalance(selectedCurrencyObj.closingBalance);
      setSelectedCurrencyId(selectedCurrencyObj.currencyId);
    }
    setSelectedFutureCurrencyName("");
    setSelectedOptionsCurrencyName("");
    setSelectedFuturesBalance(undefined);
    setSelectedOptionsBalance(undefined);
  };

  console.log("selectedBalance", selectedBalance, myBalanceListArray);

  const onChildCurrencyChange = (value) => {
    setSelectedChildCurrencyCode(value);
    const selectedCurrencyObj = myBalanceList?.find(
      (currency) => currency.currencyCode === value
    );

    if (selectedCurrencyObj) {
      setSelectedChildBalance(selectedCurrencyObj.closingBalance);
      setSelectedCurrencyId(selectedCurrencyObj.currencyId);
    }
  };

  const selectFmarginIso = (value) => {
    console.log("selected curr matched", value);
    setFmarginIsoCurrcode(value);
    if (value === fmarginWalletCurrency) {
      setSelectedBalance(fmarginWalletBalance);
      setSelectedCurrencyCode(fmarginWalletCurrency);
      setSelectedCurrencyId(fmarginWalletCurrencyId);
    }
  };

  const checkAmt = (e) => {
    const value = parseFloat(e.target.value);
    setTransferAmt(e.target.value);
    if (value <= selectedBalance && value !== "") {
      setIsTransferBtn(false);
    } else if (value <= selectedChildBalance && value !== "") {
      setIsTransferBtn(false);
    } else {
      setIsTransferBtn(true);
    }
  };

  const showMaxAmount = () => {
    if (selectedBalance) {
      setTransferAmt(selectedBalance);
      setIsTransferBtn(false);
    }
  };

  const showChildMaxAmount = () => {
    if (selectedChildBalance) {
      setTransferAmt(selectedChildBalance);
      setIsTransferBtn(false);
    }
  };

  const transferBalance = async () => {
    const payload = {};

    payload.parentId = parentId;
    payload.fromAccount = selectedFromAccount;

    if (showParentList === true && parentEmailValue !== "") {
      payload.toAccount = parentId;
    } else {
      payload.toAccount = selectedToAccount.uuid;
    }

    payload.fromWalletType = selectedFromWallet;
    payload.toWalletType = selectedToWallet;
    payload.amount = transferAmt;
    payload.currencyId = selectedCurrencyId;
    payload.securityCode = twoFactorOtp;
    if (selectedFromWallet !== "spot" || selectedToWallet !== "spot") {
      payload.marginType = fmarginType || 2;
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/transferBalanceToOtherAccount`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;

      if (res.statusCode !== 0) {
        showToast("error", res.message);
        setTwoFactorModal(false);
        setTwoFactorOtp("");
      } else {
        setTwoFactorModal(false);
        setTwoFactorOtp("");
        handleClose();

        showSubAccountBalance(walletType, marginType);
        showToast("success", res.message);
      }
    } catch (error) {
      if (error?.response?.data === "Token has been expired.") {
        //logout
      } else {
        //logout
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  console.log("isFromWalletSpot", isToWalletSpot);

  // ─── Wallet tab meta ──────────────────────────────────────────────────────
  const walletTabsMeta = [
    (brokerMarkets === undefined || brokerMarkets?.isSpot === 1) && { value: "spot", label: "Spot" },
    (brokerMarkets === undefined || brokerMarkets?.isFutures === 1) && { value: "futures", label: "Futures" },
    (brokerMarkets === undefined || brokerMarkets?.isOptions === 1) && { value: "options", label: "Options" },
  ].filter(Boolean);

  const futuresSubTabs = [
    { value: "futureWalletIso", label: "Isolated", infoKey: "isolatedInfo" },
    { value: "futureWalletCross", label: "Cross", infoKey: "crossInfo" },
  ];

  return (
    <Grid container spacing={1} sx={{ mx: 1 }}>
      {/* Sidebar */}
      <Grid size={{ xs: 12, md: 2 }}>
        <ManagementSidebar index={openIndex} />
      </Grid>

      {/* Main content */}
      <Grid size={{ xs: 12, md: 10 }}>
        <Box sx={pageWrapper}>

          {/* ── Hero Banner ── */}
          <Box
            sx={{
              ...heroBanner,
              background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.72)} 100%)`,
            }}
          >
            <Box sx={heroContent}>
              <Box sx={heroIconBadge}>
                <AccountTreeOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
              </Box>
              <Box>
                <Typography sx={heroTitle}>Asset Management</Typography>
                <Typography sx={heroSubtitle}>
                  Custom digital asset services built for asset managers and
                  sophisticated investors — family offices, hedge funds, trading firms and liquidity providers
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* ── Feature Cards ── */}
          <Box sx={featureCardsGrid}>
            {[
              {
                icon: <CallSplitOutlinedIcon sx={{ fontSize: 22 }} />,
                title: "Fund Segregation",
                desc: "Isolate assets across sub-accounts for clean risk separation between strategies.",
              },
              {
                icon: <GppGoodOutlinedIcon sx={{ fontSize: 22 }} />,
                title: "Security Controls",
                desc: "Permission-based access controls ensure ownership of funds stays entirely with you.",
              },
              {
                icon: <TrendingUpOutlinedIcon sx={{ fontSize: 22 }} />,
                title: "Multi-Strategy Trading",
                desc: "Run independent strategies in parallel across dedicated sub-accounts.",
              },
              {
                icon: <GroupsOutlinedIcon sx={{ fontSize: 22 }} />,
                title: "Team Management",
                desc: "Entrust sub-accounts to professional asset managers and trading teams.",
              },
              {
                icon: <VisibilityOutlinedIcon sx={{ fontSize: 22 }} />,
                title: "Full Transparency",
                desc: "View real-time asset balances and complete trade history at any time.",
              },
              {
                icon: <LeaderboardOutlinedIcon sx={{ fontSize: 22 }} />,
                title: "Scale Your Fund",
                desc: "Raise capital, collect management fees and leverage traded volume efficiently.",
              },
            ].map((card, i) => (
              <Box key={i} sx={featureCard}>
                <Box sx={{ ...featureCardIcon, backgroundColor: alpha(btncolor || "#1976d2", 0.1), color: btncolor }}>
                  {card.icon}
                </Box>
                <Box>
                  <Typography sx={featureCardTitle}>{card.title}</Typography>
                  <Typography sx={featureCardDesc}>{card.desc}</Typography>
                </Box>
              </Box>
            ))}
          </Box>

          {/* ── Management Panel ── */}
          <Box sx={mainCard}>
            {/* Panel header */}
            <Box sx={panelHeader}>
              <Box sx={{ ...panelHeaderAccent, background: `linear-gradient(180deg, ${alpha(btncolor || "#1976d2", 1)} 0%, ${alpha(btncolor || "#1976d2", 0.4)} 100%)` }} />
              <Box sx={{ flex: 1 }}>
                <Typography sx={panelTitle}>Sub-Account Manager</Typography>
                <Typography sx={panelSubtitle}>Select a sub-account to view balances and initiate transfers</Typography>
              </Box>
              <ContainedButton
                variant="contained"
                startIcon={<SwapHorizOutlinedIcon />}
                onClick={() => {
                  resetTransferVal();
                  setModalOpen(true);
                }}
                sx={transferBtn}
              >
                Transfer
              </ContainedButton>
            </Box>

            <Divider sx={{ borderColor: "rgba(125,125,125,0.12)" }} />

            {/* Account selector */}
            <Box sx={selectorRow}>
              <Typography sx={selectorLabel}>Sub-Account</Typography>
              <TextField
                select
                value={selectedSubAccount}
                onChange={handleChange}
                sx={{ ...modernFieldStyle, minWidth: 280 }}
                size="small"
              >
                <MenuItem value=""><em>Select Sub Account</em></MenuItem>
                {subAccountsData?.map((account) => (
                  <MenuItem key={account.uuid} value={account}>
                    {account.email}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            {/* Balance view — shown only when sub-account is selected */}
            {selectedSubAccount && (
              <Box>
                {/* Wallet type tabs */}
                <Box sx={tabsWrap}>
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                      ...tabsStyle,
                      "& .MuiTabs-indicator": {
                        backgroundColor: btncolor,
                        height: 3,
                        borderRadius: "3px 3px 0 0",
                      },
                      "& .Mui-selected": { color: `${btncolor} !important` },
                    }}
                  >
                    {walletTabsMeta.map((t) => (
                      <Tab
                        key={t.value}
                        value={t.value}
                        label={t.label}
                        sx={tabItem}
                        onClick={() => {
                          if (t.value === "spot") {
                            setWalletType("spot");
                            showSubAccountBalance("spot", "");
                          } else if (t.value === "futures") {
                            handleSelectedTab("spot");
                            marketTypeNavSeve("spot");
                            checkUserBlockStatus();
                            setWalletType("futures");
                            showSubAccountBalance("futures", "1");
                          } else if (t.value === "options") {
                            setWalletType("options");
                            setMarginType("2");
                            showSubAccountBalance("options", "2");
                          }
                        }}
                      />
                    ))}
                  </Tabs>
                </Box>

                <Box sx={{ p: { xs: 2, md: 3 } }}>

                  {/* SPOT TAB */}
                  {activeTab === "spot" && (
                    <TableContainer component={Paper} sx={modernTableContainer}>
                      <Table sx={tableStyle} stickyHeader>
                        <TableHead>
                          <TableRow sx={modernTableHeadRow}>
                            <TableCell sx={modernTableHeadCell}>
                              Asset
                              <Tooltip title={infoSections.assetInfo.content} arrow>
                                <IconButton size="small" sx={infoBtn} onClick={() => handleInfoClick("Asset", infoSections.assetInfo.content)}>
                                  <InfoIcon sx={{ fontSize: 13 }} />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                            <TableCell sx={modernTableHeadCell}>
                              Holdings
                              <Tooltip title={infoSections.holdingInfo.content} arrow>
                                <IconButton size="small" sx={infoBtn} onClick={() => handleInfoClick("Holdings", infoSections.holdingInfo.content)}>
                                  <InfoIcon sx={{ fontSize: 13 }} />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {myBalanceList.length > 0 ? (
                            myBalanceList.map((row, index) => (
                              <TableRow key={index} sx={modernTableBodyRow}>
                                <TableCell sx={modernTableBodyCell}>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <img
                                      alt={row?.currencyCode}
                                      src={ASSETICONBASEURL + row?.currencyCode.toUpperCase() + ".png"}
                                      width="22"
                                      height="22"
                                      style={{ borderRadius: "50%" }}
                                    />
                                    <Typography sx={{ fontSize: "0.88rem", fontWeight: 600, color: "var(--text-color)" }}>
                                      {row.currencyCode.toUpperCase()}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell sx={modernTableBodyCell}>{row.closingBalance}</TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={2} sx={emptyCell}>
                                <InboxOutlinedIcon sx={emptyIcon} />
                                <Typography sx={emptyText}>No balances found</Typography>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}

                  {/* FUTURES TAB */}
                  {activeTab === "futures" && (
                    <Box>
                      <Box sx={{ borderBottom: "1px solid rgba(125,125,125,0.13)", mb: 2 }}>
                        <Tabs
                          value={futureChildTab}
                          onChange={handleFutureChildTabChange}
                          sx={{
                            minHeight: 44,
                            "& .MuiTab-root": { minHeight: 44 },
                            "& .MuiTabs-indicator": { backgroundColor: btncolor, height: 2, borderRadius: "2px 2px 0 0" },
                            "& .Mui-selected": { color: `${btncolor} !important` },
                          }}
                        >
                          {futuresSubTabs.map((t) => (
                            <Tab
                              key={t.value}
                              value={t.value}
                              label={
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                  {t.label}
                                  <Tooltip title={infoSections[t.infoKey].content} arrow>
                                    <IconButton size="small" sx={infoBtn} onClick={(e) => { e.stopPropagation(); handleInfoClick(infoSections[t.infoKey].title, infoSections[t.infoKey].content); }}>
                                      <InfoIcon sx={{ fontSize: 13 }} />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              }
                              sx={subTabItem}
                              onClick={() => {
                                const mType = t.value === "futureWalletIso" ? "1" : "2";
                                setMarginType(mType);
                                showSubAccountBalance(walletType, mType);
                              }}
                            />
                          ))}
                        </Tabs>
                      </Box>
                      <TableContainer component={Paper} sx={modernTableContainer}>
                        <Table sx={tableStyle}>
                          <TableHead>
                            <TableRow sx={modernTableHeadRow}>
                              <TableCell sx={modernTableHeadCell}>Fiat</TableCell>
                              <TableCell sx={modernTableHeadCell}>Balance</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {myBalanceList.length > 0 ? (
                              myBalanceList.map((row, index) => (
                                <TableRow key={index} sx={modernTableBodyRow}>
                                  <TableCell sx={modernTableBodyCell}>{row.currencyCode}</TableCell>
                                  <TableCell sx={modernTableBodyCell}>{row.closingBalance}</TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={2} sx={emptyCell}>
                                  <InboxOutlinedIcon sx={emptyIcon} />
                                  <Typography sx={emptyText}>No balances found</Typography>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  )}

                  {/* OPTIONS TAB */}
                  {activeTab === "options" && (
                    <Box>
                      <Box sx={{ borderBottom: "1px solid rgba(125,125,125,0.13)", mb: 2 }}>
                        <Tabs
                          value="futureWalletCross"
                          sx={{
                            minHeight: 44,
                            "& .MuiTab-root": { minHeight: 44 },
                            "& .MuiTabs-indicator": { backgroundColor: btncolor, height: 2, borderRadius: "2px 2px 0 0" },
                            "& .Mui-selected": { color: `${btncolor} !important` },
                          }}
                        >
                          <Tab
                            value="futureWalletCross"
                            label={
                              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                Cross
                                <Tooltip title={infoSections.crossInfo.content} arrow>
                                  <IconButton size="small" sx={infoBtn} onClick={(e) => { e.stopPropagation(); handleInfoClick("Cross", infoSections.crossInfo.content); }}>
                                    <InfoIcon sx={{ fontSize: 13 }} />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            }
                            sx={subTabItem}
                            onClick={() => {
                              setMarginType("2");
                              showSubAccountBalance(walletType, "2");
                            }}
                          />
                        </Tabs>
                      </Box>
                      <TableContainer component={Paper} sx={modernTableContainer}>
                        <Table sx={tableStyle}>
                          <TableHead>
                            <TableRow sx={modernTableHeadRow}>
                              <TableCell sx={modernTableHeadCell}>Fiat</TableCell>
                              <TableCell sx={modernTableHeadCell}>Balance</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {myBalanceList.length > 0 ? (
                              myBalanceList.map((row, index) => (
                                <TableRow key={index} sx={modernTableBodyRow}>
                                  <TableCell sx={modernTableBodyCell}>{row.currencyCode}</TableCell>
                                  <TableCell sx={modernTableBodyCell}>{row.closingBalance}</TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={2} sx={emptyCell}>
                                  <InboxOutlinedIcon sx={emptyIcon} />
                                  <Typography sx={emptyText}>No balances found</Typography>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>

      {/* ── Info Dialog ── */}
      <Dialog
        open={openInfoDialog}
        onClose={handleCloseInfoDialog}
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          {infoContent.title}
          <IconButton
            onClick={handleCloseInfoDialog}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogContent sx={dialogContentStyle}>
          <Typography sx={dialogText}>{infoContent.content}</Typography>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <ContainedButton variant="contained" sx={{ minWidth: 100, borderRadius: "10px", textTransform: "none", fontWeight: 600 }} onClick={handleCloseInfoDialog}>
              Close
            </ContainedButton>
          </Box>
        </DialogContent>
      </Dialog>

      {/* ── Transfer Dialog ── */}
      <Dialog open={modalOpen} onClose={handleClose} fullWidth maxWidth="sm" PaperProps={{ sx: dialogPaper }}>
        <DialogTitle sx={dialogTitleStyle}>
          Transfer Assets
          <IconButton onClick={handleClose} size="small" sx={dialogCloseBtn}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogContent sx={dialogContentStyle}>

          {/* Transfer From Account */}
          <Box sx={modalFieldWrap}>
            <Typography sx={modalFieldLabel}>Transfer From Account</Typography>
            <TextField
              select
              fullWidth
              value={selectedFromAccount}
              onChange={handleFromAccountChange}
              sx={modernFieldStyle}
              size="small"
            >
              <MenuItem value="">Select Any</MenuItem>
              <MenuItem value={parentId}>{parentEmail}</MenuItem>
              {filterSubAccountData?.map((item) => (
                <MenuItem key={item.id} value={item.id}>{item.email}</MenuItem>
              ))}
            </TextField>
          </Box>

          {/* Transfer To Account */}
          <Box sx={modalFieldWrap}>
            <Typography sx={modalFieldLabel}>Transfer To Account</Typography>
            {showEmptyList && (
              <TextField select fullWidth disabled sx={modernFieldStyle} size="small">
                <MenuItem value="">—</MenuItem>
              </TextField>
            )}
            {showSubAccountList && (
              <TextField
                select
                fullWidth
                value={selectedToAccount}
                onChange={(e) => selectedToAcc(e.target.value)}
                sx={modernFieldStyle}
                size="small"
              >
                <MenuItem value="">Select Any</MenuItem>
                {subAccountsData.map((item, idx) => (
                  <MenuItem key={idx} value={item}>{item.email}</MenuItem>
                ))}
              </TextField>
            )}
            {showParentList && (
              <TextField fullWidth value={parentEmailValue} InputProps={{ readOnly: true }} sx={modernFieldStyle} size="small" />
            )}
          </Box>

          {/* Transfer From Wallet */}
          <Box sx={modalFieldWrap}>
            <Typography sx={modalFieldLabel}>Transfer From Wallet</Typography>
            <TextField
              select
              fullWidth
              value={selectedFromWallet}
              onChange={(e) => selectTransferFromWallet(e.target.value)}
              sx={modernFieldStyle}
              size="small"
            >
              <MenuItem value="">Select From Wallet</MenuItem>
              <MenuItem value="spot">Spot</MenuItem>
              {isFromWalletSpot && brokerMarkets?.isFutures === 1 && (
                <MenuItem value="futures">Futures</MenuItem>
              )}
              {isFromWalletSpot && brokerMarkets?.isOptions === 1 && (
                <MenuItem value="options">Options</MenuItem>
              )}
            </TextField>
          </Box>

          {/* Transfer To Wallet */}
          <Box sx={modalFieldWrap}>
            <Typography sx={modalFieldLabel}>Transfer To Wallet</Typography>
            <TextField
              select
              fullWidth
              value={selectedToWallet}
              onChange={(e) => selectTransferToWallet(e.target.value)}
              sx={modernFieldStyle}
              size="small"
            >
              <MenuItem value="">Select To Wallet</MenuItem>
              <MenuItem value="spot">Spot</MenuItem>
              {!isToWalletSpot && brokerMarkets?.isFutures === 1 && (
                <MenuItem value="futures">Futures</MenuItem>
              )}
              {!isToWalletSpot && brokerMarkets?.isOptions === 1 && (
                <MenuItem value="options">Options</MenuItem>
              )}
            </TextField>
          </Box>

          {/* Margin */}
          {marginTypeList && (
            <Box sx={modalFieldWrap}>
              <Typography sx={modalFieldLabel}>Margin Type</Typography>
              <TextField
                select
                fullWidth
                value={selectedMargin}
                onChange={(e) => selectMarginForTransfer(e.target.value)}
                disabled={!isIsolated}
                sx={modernFieldStyle}
                size="small"
              >
                <MenuItem value="">Select Margin Type</MenuItem>
                {isIsolated && <MenuItem value="iso">ISOLATED</MenuItem>}
                <MenuItem value="cross">CROSS</MenuItem>
              </TextField>
            </Box>
          )}

          {/* Choose Asset */}
          <Box sx={modalFieldWrap}>
            <Typography sx={modalFieldLabel}>Choose Asset To Transfer</Typography>
            {(parentAssetToTransfer || childAssetToTransfer) && (
              <TextField
                select
                fullWidth
                value={selectedCurrencyCode}
                onChange={(e) => onCurrencyChange(e.target.value)}
                sx={modernFieldStyle}
                size="small"
              >
                <MenuItem value="">Select Asset To Transfer</MenuItem>
                {myBalanceListArray.map((item, idx) => (
                  <MenuItem key={idx} value={item.currencyCode}>{item.currencyCode}</MenuItem>
                ))}
              </TextField>
            )}
            {futureAssets && (
              <TextField
                select
                fullWidth
                value={selectedFutureCurrencyName}
                onChange={(e) => onFutureCurrencyChange(e.target.value)}
                sx={modernFieldStyle}
                size="small"
              >
                <MenuItem value="">Select Asset To Transfer</MenuItem>
                <MenuItem value="USD">USD</MenuItem>
                <MenuItem value="USDT">USDT</MenuItem>
              </TextField>
            )}
            {optionsAssets && (
              <TextField
                select
                fullWidth
                value={selectedOptionsCurrencyName}
                onChange={(e) => onOptionCurrencyChange(e.target.value)}
                sx={modernFieldStyle}
                size="small"
              >
                <MenuItem value="">Select Asset To Transfer</MenuItem>
                <MenuItem value="USDT">USDT</MenuItem>
              </TextField>
            )}
            {futureIsoMarginWalletCurrencyList && (
              <TextField
                select
                fullWidth
                value={fmarginIsoCurrcode}
                onChange={(e) => selectFmarginIso(e.target.value)}
                sx={modernFieldStyle}
                size="small"
              >
                <MenuItem value="">Select Asset To Transfer</MenuItem>
                <MenuItem value={fmarginWalletCurrency}>{fmarginWalletCurrency}</MenuItem>
              </TextField>
            )}
          </Box>

          {/* Amount */}
          <Box sx={modalFieldWrap}>
            <Typography sx={modalFieldLabel}>Amount</Typography>
            <TextField
              fullWidth
              type="number"
              autoComplete="off"
              value={transferAmt}
              onChange={(e) => checkAmt(e)}
              onWheel={(e) => e.target.blur()}
              sx={modernFieldStyle}
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {selectedBalance !== undefined && selectedCurrencyCode !== undefined && (
                      <Typography
                        onClick={showMaxAmount}
                        sx={{ fontSize: "0.72rem", fontWeight: 700, cursor: "pointer", color: btncolor, letterSpacing: "0.04em" }}
                      >
                        MAX
                      </Typography>
                    )}
                    {selectedChildBalance !== undefined && selectedChildCurrencyCode !== undefined && (
                      <Typography
                        onClick={showChildMaxAmount}
                        sx={{ fontSize: "0.72rem", fontWeight: 700, cursor: "pointer", color: btncolor, letterSpacing: "0.04em" }}
                      >
                        MAX
                      </Typography>
                    )}
                  </InputAdornment>
                ),
              }}
            />
            {selectedBalance !== undefined && selectedCurrencyCode !== undefined && (
              <Typography sx={availableText}>Available: {selectedBalance} {selectedCurrencyCode}</Typography>
            )}
            {selectedFutureCurrencyName && (
              <Typography sx={availableText}>Available: {selectedFuturesBalance || 0} {selectedFutureCurrencyName}</Typography>
            )}
            {selectedOptionsCurrencyName && (
              <Typography sx={availableText}>Available: {selectedOptionsBalance || 0} {selectedOptionsCurrencyName}</Typography>
            )}
          </Box>

          <ContainedButton
            variant="contained"
            fullWidth
            sx={{ mt: 1, height: 46, borderRadius: "10px", textTransform: "none", fontWeight: 600, fontSize: "0.9rem" }}
            onClick={() => setTwoFactorModal(true)}
            disabled={!transferAmt}
          >
            Confirm Transfer
          </ContainedButton>
        </DialogContent>
      </Dialog>

      {/* ── 2FA Modal ── */}
      <ModalContent
        open={twoFactorModal}
        onClose={() => setTwoFactorModal(false)}
        title="Security Authentication"
        width="xs"
      >
        <Typography variant="body2" gutterBottom sx={{ textAlign: "center", color: "var(--text-color)", opacity: 0.75 }}>
          Input OTP from your Google Authenticator
        </Typography>
        <TextField
          autoComplete="off"
          fullWidth
          type="number"
          variant="outlined"
          placeholder="Two-Factor Authenticator code"
          value={twoFactorOtp}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "").slice(0, 6);
            setTwoFactorOtp(value);
          }}
          onWheel={(e) => e.target.blur()}
          autoFocus
          margin="normal"
          sx={modernFieldStyle}
        />
        <ContainedButton
          variant="contained"
          fullWidth
          onClick={twoFactorOtp?.length === 6 && transferBalance()}
          disabled={twoFactorOtp == ""}
          sx={{ mt: 3, height: 46, borderRadius: "10px", textTransform: "none", fontWeight: 600 }}
        >
          Confirm
        </ContainedButton>
      </ModalContent>
    </Grid>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 1, md: 2 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};

// Feature cards grid
const featureCardsGrid = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
  gap: 2,
  mb: 3,
};

const featureCard = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1.75,
  backgroundColor: "var(--body-color-less)",
  borderRadius: "14px",
  border: "1px solid rgba(125,125,125,0.13)",
  p: 2.25,
  transition: "box-shadow 0.2s ease, transform 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
  },
};

const featureCardIcon = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const featureCardTitle = {
  fontSize: "0.88rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.25,
  mb: 0.5,
};

const featureCardDesc = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.6,
  lineHeight: 1.6,
};

// Main card (management panel)
const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
  mb: 3,
};

const panelHeader = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  px: { xs: 2, md: 3 },
  py: 2,
  backgroundColor: "var(--body-color-less2)",
};

const panelHeaderAccent = {
  width: 4,
  borderRadius: "4px",
  alignSelf: "stretch",
  minHeight: 36,
  flexShrink: 0,
};

const panelTitle = {
  fontSize: "0.95rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const panelSubtitle = {
  fontSize: "0.75rem",
  color: "var(--text-color)",
  opacity: 0.55,
  mt: 0.25,
};

const transferBtn = {
  height: 40,
  px: 2.5,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.85rem",
  whiteSpace: "nowrap",
  flexShrink: 0,
};

// Account selector row
const selectorRow = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  flexWrap: "wrap",
  px: { xs: 2, md: 3 },
  py: 2,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
};

const selectorLabel = {
  fontSize: "0.82rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.65,
  whiteSpace: "nowrap",
};

// Tabs
const tabsWrap = {
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  px: { xs: 1, md: 2 },
  backgroundColor: "var(--body-color-less2)",
};

const tabsStyle = {
  minHeight: 52,
  "& .MuiTab-root": { minHeight: 52 },
};

const tabItem = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.88rem",
  color: "var(--text-color)",
  opacity: 0.65,
  letterSpacing: "0.01em",
  px: 2,
  "&.Mui-selected": { color: "var(--text-color)", opacity: 1 },
};

const subTabItem = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.82rem",
  color: "var(--text-color)",
  opacity: 0.65,
  px: 2,
  minHeight: 44,
  "&.Mui-selected": { color: "var(--text-color)", opacity: 1 },
};

// Info button
const infoBtn = {
  ml: 0.5,
  opacity: 0.45,
  "&:hover": { opacity: 0.85 },
  color: "var(--text-color)",
};

// Tables
const modernTableContainer = {
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "none",
  overflow: "hidden",
  backgroundColor: "var(--body-color-less)",
};

const tableStyle = {
  minWidth: 320,
};

const modernTableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.5,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
};

const emptyCell = {
  textAlign: "center",
  py: 6,
  borderBottom: 0,
};

const emptyIcon = {
  fontSize: 44,
  color: "var(--text-color)",
  opacity: 0.3,
  mb: 1,
};

const emptyText = {
  fontSize: "0.88rem",
  color: "var(--text-color)",
  opacity: 0.55,
};

// Dialogs
const dialogPaper = {
  borderRadius: "16px",
  minWidth: { xs: "85%", sm: 440 },
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
  overflow: "hidden",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
};

const dialogTitleStyle = {
  textAlign: "center",
  fontWeight: 700,
  fontSize: "1.1rem",
  py: 2.25,
  color: "var(--text-color)",
  backgroundColor: "var(--popupheader-color)",
  position: "relative",
};

const dialogCloseBtn = {
  position: "absolute",
  right: 12,
  top: "50%",
  transform: "translateY(-50%)",
  color: "var(--text-color)",
  opacity: 0.6,
};

const dialogContentStyle = {
  pt: 2.5,
  pb: 3,
  px: { xs: 2, md: 3 },
  backgroundColor: "var(--popupbody-color)",
};

const dialogText = {
  fontSize: "0.9rem",
  color: "var(--text-color)",
  opacity: 0.8,
  lineHeight: 1.65,
};

// Modal fields
const modalFieldWrap = {
  mb: 2,
};

const modalFieldLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.6,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  mb: 0.75,
};

const modernFieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "0.88rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiSelect-select": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.25)" },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.45)" },
  "& .MuiInputLabel-root": { display: "none" },
  "& legend": { display: "none" },
  "& fieldset": { top: 0 },
  "& .MuiInputBase-input.Mui-disabled": { color: "var(--text-color)", WebkitTextFillColor: "var(--text-color)", opacity: 0.45 },
};

const availableText = {
  fontSize: "0.75rem",
  color: "var(--text-color)",
  opacity: 0.6,
  mt: 0.5,
};

export default AssetManagement;
